import { render, staticRenderFns } from "./RdmCompanyAgeBand.vue?vue&type=template&id=22737038&scoped=true&"
import script from "./RdmCompanyAgeBand.vue?vue&type=script&lang=ts&"
export * from "./RdmCompanyAgeBand.vue?vue&type=script&lang=ts&"
import style0 from "./RdmCompanyAgeBand.vue?vue&type=style&index=0&id=22737038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22737038",
  null
  
)

export default component.exports